// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_headerChildren__ZZsNZ {
  margin-left: auto;
  margin-right: 1rem;
  position: absolute;
  bottom: 1rem; }

.styles_footer__NHxQO {
  display: flex;
  justify-content: flex-end; }

.styles_screen__qzY85 > div > div:last-child {
  max-width: 0%;
  width: 0% !important; }

.styles_screen__qzY85 > div > div:nth-child(2) {
  width: 75% !important; }

.styles_emptyCard__py58r {
  border-style: ridge;
  padding: 4rem 2rem;
  display: flex;
  height: 18rem;
  width: 75%;
  margin: 0rem 4rem;
  border: none;
  box-shadow: 0px 0px 10px #8080805c; }
  .styles_emptyCard__py58r > div {
    display: flex;
    flex-direction: column;
    align-items: center; }
  .styles_emptyCard__py58r .styles_emptyImage__mOf5j {
    width: 10rem;
    height: 10rem;
    object-fit: contain; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/screens/BoothsScreen/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YACF,EAAA;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAA;;AAG3B;EAGM,aAAa;EACb,oBAAoB,EAAA;;AAJ1B;EAQM,qBAAqB,EAAA;;AAM3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,kCCtBgB,EAAA;EDclB;IAWI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAA;EAbvB;IAiBI,YAAY;IACZ,aAAa;IACb,mBAAmB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.headerChildren {\n  margin-left: auto;\n  margin-right: 1rem;\n  position: absolute;\n  bottom: 1rem\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.screen {\n  &>div {\n    &>div:last-child {\n      max-width: 0%;\n      width: 0% !important;\n    }\n\n    &>div:nth-child(2) {\n      width: 75% !important;\n    }\n  }\n}\n\n\n.emptyCard {\n  border-style: ridge;\n  padding: 4rem 2rem;\n  display: flex;\n  height: 18rem;\n  width: 75%;\n  margin: 0rem 4rem;\n  border: none;\n  box-shadow: 0px 0px 10px $grey36;\n\n  &>div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .emptyImage {\n    width: 10rem;\n    height: 10rem;\n    object-fit: contain;\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerChildren": `styles_headerChildren__ZZsNZ`,
	"footer": `styles_footer__NHxQO`,
	"screen": `styles_screen__qzY85`,
	"emptyCard": `styles_emptyCard__py58r`,
	"emptyImage": `styles_emptyImage__mOf5j`
};
export default ___CSS_LOADER_EXPORT___;
